function Navbar(){
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container-fluid">
                
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                    <a className="nav-link active" aria-current="page" href="#presentazione">Home</a>
                    </li>

                    <li className="nav-item">
                    <a className="nav-link" href="#prenotazione">Prenotazione</a>
                    </li>

                    <li className="nav-item">
                    <a className="nav-link" href="#negozio">Prodotti</a>
                    </li>

                    <li className="nav-item">
                    <a className="nav-link" href="#informazioni">Info</a>
                    </li>
                    
                </ul>
                
                </div>
            </div>
        </nav>

    );      
}

export default Navbar;